import { AdminGrowthInvestment } from "./AdminGrowthInvestment"

export class SaveAdminGrowthInvestment extends AdminGrowthInvestment {
  constructor(data: Partial<SaveAdminGrowthInvestment> = {}) {
    super(data)
  }
}
